import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useT } from "@/lib/i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback({ onLogin }) {
  const t = useT();
  const hasProcessed = useRef(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "?")).get("session_id");

    if (!sessionId) {
      navigate("/login");
      return;
    }

    axios
      .post(`${API}/auth/session?session_id=${encodeURIComponent(sessionId)}`, {}, { withCredentials: true })
      .then((res) => {
        onLogin(res.data);
        navigate("/");
      })
      .catch(() => {
        navigate("/login?oauth_error=legacy_session_retired");
      });
  }, [navigate, onLogin]);

  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-blue-700 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-sm text-slate-500">{t("auth_callback.signing_in", "Signing you in...")}</p>
      </div>
    </div>
  );
}
